import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";

const fetcher = (url) => async () => (await api.get(url)).data;

export const useBlocks = () => useQuery({ queryKey: ["content", "blocks"], queryFn: fetcher("/content/blocks"), staleTime: 5 * 60_000 });
export const useFaq = () => useQuery({ queryKey: ["content", "faq"], queryFn: fetcher("/content/faq") });
export const useResources = () => useQuery({ queryKey: ["content", "resources"], queryFn: fetcher("/content/resources") });
export const useCrisisLines = () => useQuery({ queryKey: ["content", "crisis"], queryFn: fetcher("/content/crisis-lines") });
export const useCounselors = () => useQuery({ queryKey: ["content", "counselors"], queryFn: fetcher("/content/counselors") });
export const useTrustedProviders = () => useQuery({ queryKey: ["content", "trusted"], queryFn: fetcher("/content/trusted-providers") });
export const usePublicSettings = () => useQuery({ queryKey: ["content", "public-settings"], queryFn: fetcher("/content/public-settings"), staleTime: 5 * 60_000 });

export const JOURNEY_KEYS = ["journey.1", "journey.2", "journey.3", "journey.4", "journey.5"];

export function journeyStations(blocks) {
  return JOURNEY_KEYS.map((k, i) => ({ key: k, label: blocks?.[k]?.title || ["Free Sign Up", "Care Intake", "Video Series", "In-Person Intake", "Counseling Sessions"][i], body: blocks?.[k]?.body || "" }));
}
